export default __webpack_public_path__ + "b6fad483421359cf62430ad2a791d94c.png";